import React from "react";
import {MessageWithActionAndData} from "@me8eon/sessions_messages";
import {ThemedIcon} from "@me8eon/icons";
import TypingEffect from "../../ai-assist-refactored/utils/typing-effect/TypingEffect";

export const ToolCallsAssistantMessage: React.FC<MessageWithActionAndData> = (message) => {
    const toolsLength = message.toolCalls ? message.toolCalls.length : 0;
    return (
        <div className="bot-header">
            <div className="eon-logo">
                <ThemedIcon name={"AiIcon"}/>
            </div>
            <div className="bot-reply-container">
                <TypingEffect className="bot-text" text={`I am calling ${toolsLength} ${toolsLength > 1 ? "tools" : "tool"}...`} speed={1}/>
            </div>
        </div>
    )
}
